// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"_Z-z","sponsoredTooltipWrapper":"a0-z","sponsoredTooltip":"b0-z","newCard":"c0-z"};